import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function couponVerifyReducer(state = initialState, action) {
    
    const {type, payload} = action;
    switch (type) {
        case t.POST_COUPON_VERIFY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.POST_COUPON_VERIFY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload
            };
        case t.POST_COUPON_VERIFY_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}